module.exports = __webpack_public_path__ + "images/tomoscf003681f61ce69fce1c1605bfe2d7ba.png";